import React from 'react';

/**
 * Tag Internacional/Nacional do Financeiro (Rafael, 28/09: "inter = fornecedor com pagamento no
 * exterior"). `natureza` vem da API ('internacional' | 'nacional'); ausente = registro sem vínculo
 * com orçamento → sem tag.
 */
export const naturezaDaLista = (lista) => {
    const naturezas = (lista || []).map((x) => x && x.natureza).filter(Boolean);
    if (naturezas.includes('internacional')) return 'internacional';
    return naturezas.length ? 'nacional' : null;
};

const TagNatureza = ({ natureza, style }) => {
    const base = Object.assign({ marginLeft: 6 }, style || {});
    if (natureza === 'internacional') {
        return <span className="fin-pp__minitag is-info" style={base} title="Fornecedor com pagamento no exterior">Internacional</span>;
    }
    if (natureza === 'nacional') {
        return <span className="fin-pp__minitag" style={base} title="Fornecedor pago no Brasil">Nacional</span>;
    }
    return null;
};

export default TagNatureza;
